(function($) {

	$.fn.footerNav = function() {

		var init = function() {

			var allowableBreakpoints = ['palm', 'portable-and-up'],
				currentBreakpoint = $.getBreakpoint();

			// if current breakpoint is not in allowableBreakpoints, do nothing
			if (allowableBreakpoints.indexOf(currentBreakpoint) < 0) {
			    return;
			}

			// else, continue...

			// on click of nav toggle button...
			$('.js-site-foot__nav__toggle').on('click', function () {

				var parentNavItem = $(this).parents('.js-site-foot__nav__group'),
					thisList = parentNavItem.children('.js-site-foot__nav__list'),
					otherNavItems = $('.js-site-foot__nav__group').not(parentNavItem),
					slideSpeed = 200;

				// slide up all other nav items
				$('.js-site-foot__nav__list').not(thisList).slideUp(slideSpeed);

				// toggle display of current nav item
				thisList.slideToggle(slideSpeed);

				// remove 'is-open' class from all other nav items
				otherNavItems.removeClass('is-open');

				// toggle 'is-open' class on current nav item
				parentNavItem.toggleClass('is-open');

			});

		};

		init();
		return this;
	};

}($));
